import React from 'react'
import { Link } from "react-router-dom"
import { Products } from "../Products"

const Ourproduct = () => {
  return (
    <div className='w-full min-h-screen bg-[#FAFAFA]'>

      {/* Header Section */}
      <div className='w-full px-4 sm:px-[50px] py-[40px] sm:py-[60px] flex flex-col items-center justify-center gap-[12px] bg-[#EE645A] font-poppins text-center text-white'>
        <h1 className='font-bold text-[28px] sm:text-[40px]'>
          Our Products
        </h1>

        <p className='max-w-[900px] h-auto font-normal text-[14px] sm:text-[18px] text-[#FFFFFFCC] mt-3'>
          Support our mission by purchasing handcrafted items made by women artisans and underprivileged communities. Every purchase makes a direct impact on changing lives.
        </p>
      </div>

      {/* Products Section */}
      <div className='max-w-[1320px] mx-auto px-4 py-12'>
        
        {/* Products Grid */}
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center'>
          {Products.map((product, idx) => {
            return (
              <Link
                to={`/products/${idx}`}
                key={idx}
                className='w-full max-w-[424px] bg-white rounded-[16px] overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105 group'
              >
                {/* Image Container */}
                <div className='relative overflow-hidden bg-gray-200 h-[280px]'>
                  <img
                    src={product.img}
                    alt={product.name}
                    className='w-full h-full object-cover group-hover:scale-110 transition-transform duration-300'
                  />
                </div>

                {/* Content Section */}
                <div className='bg-[#EE645A] p-6 text-white'>
                  
                  {/* Product Name */}
                  <h2 className='text-[20px] sm:text-[22px] font-bold leading-tight mb-3 line-clamp-2'>
                    {product.name}
                  </h2>

                  {/* Product Description */}
                  <p className='text-[14px] sm:text-[15px] text-[#FFFFFFCC] mb-4 line-clamp-2 leading-relaxed'>
                    {product.desc}
                  </p>

                  {/* Price Section */}
                  <div className='flex items-center justify-between pt-3 border-t border-[#FFFFFF33]'>
                    <h3 className='font-bold text-[20px] sm:text-[24px]'>
                      {product.price}
                    </h3>
                    <button className='px-4 py-2 bg-white text-[#EE645A] font-bold text-[14px] rounded-[6px] hover:bg-gray-100 transition-colors'>
                      View
                    </button>
                  </div>

                </div>
              </Link>
            )
          })}
        </div>

        {/* No Products Message */}
        {Products.length === 0 && (
          <div className='text-center py-12'>
            <p className='text-[16px] text-[#666666]'>No products available at the moment</p>
          </div>
        )}
      </div>

      {/* CTA Section */}
      {/* <div className='bg-white border-t border-[#EEE] py-12 px-4'>
        <div className='max-w-[1200px] mx-auto text-center'>
          <h2 className='text-[24px] sm:text-[32px] font-bold text-[#000000] mb-4'>
            Support Artisans & Communities
          </h2>
          <p className='text-[15px] sm:text-[16px] text-[#666666] mb-6 max-w-[700px] mx-auto'>
            Every purchase directly supports the livelihood of women artisans and underprivileged communities. Help us create sustainable livelihoods through traditional crafts.
          </p>
          <div className='flex flex-wrap justify-center gap-4'>
            <button className='px-8 py-3 bg-[#EE645A] text-white font-bold rounded-[8px] hover:bg-[#D84530] transition-colors'>
              Browse All Products
            </button>
            <button className='px-8 py-3 border-2 border-[#EE645A] text-[#EE645A] font-bold rounded-[8px] hover:bg-[#FFF8F6] transition-colors'>
              Learn More
            </button>
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default Ourproduct